import React from 'react';
import {ReactComponent as FacebookIcon} from '../../assets/images/icon-facebook.svg';
import {ReactComponent as InstagramIcon} from '../../assets/images/icon-instagram.svg';

const socialLinks = [
    {
        name:'facebook',
        icon:<FacebookIcon/>,
        target:"https://facebook.com"
    },
    {
        name:'instagram',
        icon:<InstagramIcon/>,
        target:"https://instagram.com"
    }
]
const SuluxSocial = () => {
    return(
        <ul className="c-social flex items-center">
            {socialLinks.map((item,i)=>{
                return(
                    <li key={i} className="">
                        <a href={item.target} className="block px-10" target="_blank" title={item.name} rel="noreferrer">{item.icon}</a>
                    </li>
                )
            })}
           
        </ul>
    )
}
export default SuluxSocial;